import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ChangeOfOrder = () => (
  <QPhototModuleSubtopic
    title="Change of order"
    videos={[
      "https://www.youtube.com/embed/8U8GH-REBpg",
      "https://www.youtube.com/embed/Vo3Hb0Ufk7Y",
      "https://www.youtube.com/embed/AFUyqgiEcBA",
      "https://www.youtube.com/embed/Oi957kbWSCQ"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_42.jpeg"
        },
        {
            image:"/cal_43.jpeg"
        },
        {
            image:"/cal_44.jpeg"
        },
        {
            image:"/cal_45.jpeg"
        },
        {
            image:"/cal_46.jpeg"
        },
        {
            image:"/cal_47.jpeg"
        },
    ]}
    exampleVideos={[]}
  />
);

export default ChangeOfOrder;
